import React from "react";

export const BurgerIcon = ({fill = '#222'}) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.7998 13.375C15.1449 13.3751 15.4248 13.6549 15.4248 14C15.4248 14.3451 15.1449 14.6249 14.7998 14.625H5.2002C4.85502 14.625 4.5752 14.3452 4.5752 14C4.5752 13.6548 4.85502 13.375 5.2002 13.375H14.7998ZM14.7998 9.375C15.1449 9.37511 15.4248 9.65489 15.4248 10C15.4248 10.3451 15.1449 10.6249 14.7998 10.625H5.2002C4.85502 10.625 4.5752 10.3452 4.5752 10C4.5752 9.65482 4.85502 9.375 5.2002 9.375H14.7998ZM14.7998 5.375C15.1449 5.37511 15.4248 5.65489 15.4248 6C15.4248 6.34511 15.1449 6.62489 14.7998 6.625H5.2002C4.85502 6.625 4.5752 6.34518 4.5752 6C4.5752 5.65482 4.85502 5.375 5.2002 5.375H14.7998Z"
                  fill={fill}/>
        </svg>
    );
}